import { useContext } from 'react'
import { HeaderContext } from '../providers/HeaderProvider'

export const useHeader = () => {
  return useContext(HeaderContext)
}
